import React, { Component, Suspense } from 'react';
import * as style from './twoColMailChimpForm.module.scss';
import * as buttonStyle from '../ui/button.module.scss';
import $ from 'jquery';
import FormData from 'form-data';

import translations from '../../utils/translations';
import Loading from '../global/loading';

class TwoColMailChimpForm extends Component {
	constructor(props) {
		super(props);
		this.onSubmit = this.onSubmit.bind(this);
	};

	getLang(itemid) {
		if (itemid.includes("en")) {
			this.lang = 'en';
			return 'en';
		}
		if (itemid.includes("es")) {
			this.lang = 'es';
			return 'es';
		}
	}

	onSubmit = (e) => {
		e.preventDefault();
		const formData = new FormData(e.target);
		if (formData.get('FNAME') === "") {
			$('#mce-error-response').html(translations.t('Please enter your first name.'));
			$('#mce-error-response').css('display', 'block');
			return;
		}
		if (formData.get('EMAIL') === "") {
			$('#mce-error-response').html(translations.t('Please enter your email address.'));
			$('#mce-error-response').css('display', 'block');
			return;
		}
		const data = {
			'EMAIL': formData.get('EMAIL'),
			'FNAME': formData.get('FNAME'),
			'b_f638b14bd99d4a67f72a673b2_b758bb0b52': ''
		};
		const destination = this.props.mailchimp_destination || '/thankyou-2'
		$.ajax({
			url: 'https://outrider.us12.list-manage.com/subscribe/post-json?u=f638b14bd99d4a67f72a673b2&amp;id=b758bb0b52&c=?',
			dataType: 'jsonp',
			data: data,
			cache: false,
			success: function (data) {
				if (data.result && data.result === 'error') {
					$('#mce-error-response').html(data.msg);
					$('#mce-error-response').css('display', 'block');
				} else if (data.result && data.result === 'success') {
					if (this.lang === 'en') {
						window.location.href = destination;
					}
					if (this.lang === 'es') {
						window.location.href = destination;
					}
					window.location.href = destination;
				} else {
					$('#mce-error-response').html('An unknown error has occurred');
					$('#mce-error-response').css('display', 'block');
				}
			}.bind(this),
			error: function (xhr, status, err) {
				$('#mce-error-response').html(err.toString());
				$('#mce-error-response').css('display', 'block');
			}
		});
	};

	render() {
		this.getLang(this.props.itemid);
		const isSSR = typeof window === "undefined";

		return (
			<>
      		{!isSSR && (
			<Suspense fallback={<Loading/>}>
				<div className={`${style.twoColWrap} twoColMailChimpForm`}>
					<div className={`${style.twoColMailChimpFormInset}`}>

						<style>{`.mc-modal,.mc-modal[style],.mc-banner,.mc-banner[style],.mc-modal-bg,.mc-modal-bg[style]{display:none!important;visibility:hidden!important;overflow:hidden!important;height:0px!important;width:0px!important;opacity:0!important;}`}</style>

						<div className={`${style.twoColWrapLeftCol}`}>
							<h1>{this.props.first_column_heading}</h1>
							<div dangerouslySetInnerHTML={{ __html: this.props.first_column_content }}></div>
						</div>

						<div className={`${style.twoColWrapRightCol}`}>
							<div className={`${style.mcEmbedSignupWrap}`}>

								<p className={`${style.rightColCalloutHeading}`}>
									{this.props.callout_heading}
								</p>

								<h3 className={`${style.rightColCalloutSubtitle}`}>
									{this.props.callout_subtitle}
								</h3>

								<div id="mc_embed_signup" className={`${style.form} text-block page-block normal-text-block`}>
									<div id="mailchimp-sign-up-form">
										<form onSubmit={this.onSubmit} id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_blank" noValidate>

											<div className={`${style.inputGroup} mc-field-group`}>

												{/*
												placeholder={translations.t('First Name')}
											*/}
												<label htmlFor="mce-FNAME" style={{ display: 'block' }}>{translations.t('First Name')}</label>
												<input
													type="text"
													name="FNAME"
													className={`${style.textInput} required fname`}
													id="mce-FNAME"
													required
												/>

												{/*
												placeholder={translations.t('Email Address')}
											*/}
												<label htmlFor="mce-EMAIL" style={{ display: 'block' }}>{translations.t('Email Address')}</label>
												<input
													type="email"
													name="EMAIL"
													className={`${style.emailInput} required email`}
													id="mce-EMAIL"
													required
												/>

												<p className={`${style.rightColCalloutText}`}>
													{this.props.callout_text}
												</p>

												<div id="mce-responses" className="clear">
													<div className={`${style.errorResponse} response`} id="mce-error-response" style={{ display: 'none' }}></div>
												</div>

												<div className={`text-align--center`}>
													<button
														type="submit"
														name="subscribe"
														id="mc-embedded-subscribe"
														className={`${buttonStyle.button} ${buttonStyle.orangeButton} ${style.submitButton}`}>
														<span className={buttonStyle.mainText}>{translations.t('SUBSCRIBE')}</span>
													</button>
												</div>

											</div>

										</form>
									</div>
								</div>

							</div>
						</div>

					</div>
				</div>
			</Suspense>
			)}
			</>
		);
	};
};

export default TwoColMailChimpForm;
